<template>
    <div class="hts-charges mb-4">
        <hts-form @submit="update">
            <div
                class="border rounded"
                :class="{ 'mb-2': editable }">
                <div
                    class="grid gap-2 p-1 border-b"
                    :class="{ 'grid-cols-3': simple, 'grid-cols-9': !simple }">
                    <div>
                        <span>
                            {{ nameLabel }}
                        </span>
                    </div>
                    <div>
                        <span>
                            {{ $t('labels.shipingCost') }}
                        </span>
                    </div>
                    <template v-if="!simple">
                        <div>
                            <span>
                                Chi phí tài chính
                            </span>
                        </div>
                        <div>
                            <span>
                                Hoa hồng
                            </span>
                        </div>
                        <div>
                            <span>
                                Chi phí hoa hồng
                            </span>
                        </div>
                        <div>
                            <span>
                                Tổng chi phí
                            </span>
                        </div>
                        <div>
                            <span>
                                Doanh thu
                            </span>
                        </div>
                        <div>
                            <span>
                                Lợi nhuận
                            </span>
                        </div>
                    </template>
                    <div />
                </div>
                <template
                    v-for="(charge, index) in cCharges"
                    :key="index">
                    <div
                        class="grid gap-2 my-1 px-1"
                        :class="{ 'grid-cols-3': simple, 'grid-cols-9': !simple }">
                        <div>
                            {{ charge[nameKey] }}
                        </div>
                        <template v-if="editable">
                            <hts-form-input
                                v-model="cCharges[index].buyingPrice"
                                type="number"
                                required
                                :readonly="!editable" />
                        </template>
                        <template v-else>
                            <div>
                                {{ $formatters.formatCurrency(charge.buyingPrice + charge.inversedRoutePrice, 0) }}
                            </div>
                        </template>
                        <template v-if="!simple">
                            <div>
                                {{ $formatters.formatCurrency(charge.financeFee, 0) }}
                            </div>
                            <div>
                                {{ $formatters.formatCurrency(charge.commission, 0) }}
                            </div>
                            <div>
                                {{ $formatters.formatCurrency(charge.commissionFee, 0) }}
                            </div>
                            <div>
                                {{ $formatters.formatCurrency(charge.cost, 0) }}
                            </div>
                            <div>
                                {{ $formatters.formatCurrency(charge.revenue, 0) }}
                            </div>
                            <div>
                                {{ $formatters.formatCurrency(charge.profit, 0) }}
                            </div>
                        </template>
                        <div class="flex items-center">
                            <hts-form-button
                                v-if="editable"
                                color="error"
                                size="small"
                                icon-name="hi-x-mark-icon"
                                @click="removeCharge(index)">
                                Xóa
                            </hts-form-button>
                        </div>
                    </div>
                </template>
                <template v-if="cCharges.length <= 0">
                    <p class="px-1">
                        Hiện tại chưa có chi phí nào.
                    </p>
                </template>
                <hts-form-button
                    v-if="editable && cCharges.length < 1"
                    size="small"
                    color="primary"
                    icon-name="hi-plus-icon"
                    class="my-1 ml-1"
                    @click="addCharge">
                    Thêm
                </hts-form-button>
            </div>
            <hts-form-button
                v-if="editable"
                type="submit"
                color="primary"
                icon-name="hi-check-icon"
                :outline="false"
                :loading="updating">
                {{ $t('labels.save') }}
            </hts-form-button>
        </hts-form>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: {
    type: Array,
    required: true
  },
  api: Object,
  uriParams: Object,
  editable: Boolean,
  simple: Boolean,
  nameKey: { type: String, default: 'name' },
  nameLabel: { type: String, default: 'Tên phí' }
})
const { modelValue, api, uriParams, editable, nameKey } = toRefs(props)
const emits = defineEmits(['update:modelValue', 'modified'])
const cCharges = ref<any[]>([])
const updating = ref(false)
onMounted(() => {
  cCharges.value = modelValue.value
})
const update = async () => {
  if (!editable.value) {
    return
  }
  if (!api?.value) {
    return
  }
  updating.value = true
  const { data } = await $api(api.value, { uriParams: uriParams?.value, body: { charges: cCharges.value } })
  emits('modified')
  emits('update:modelValue', cCharges.value)
  updating.value = false
}
const addCharge = () => {
  if (!editable.value) {
    return
  }
  if (cCharges.value.length) {
    return
  }
  cCharges.value.push({
    [nameKey.value]: 'Phí vận chuyển',
    buyingPrice: '',
    sellingPrice: '',
    commission: '',
    financeFee: '',
    unit: 1
  })
}
const removeCharge = (index: number) => {
  if (!editable.value) {
    return
  }
  if (cCharges.value[index]) {
    cCharges.value.splice(index, 1)
  }
}
const refresh = () => {
  cCharges.value = modelValue.value
}
defineExpose({ refresh })
</script>
